// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge--floats[data-v-65a962b1] {\n  color: #231f20;\n}", ""]);
// Exports
module.exports = exports;
